(function () {
    'use strict';

    angular.module('vrm.components')
        .factory('cancelInterceptor', ['VrmRequestCancellation', function (VrmRequestCancellation, $q) {
            return {
                'request': function (config) {
                    config.timeout = VrmRequestCancellation.getRequestTokensStatsAndWidgets(config);
                    return config;
                }
            };
        }])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('cancelInterceptor');
        }]);
})();
